
// const rwGwpDebug = true; // see global-resources.liquid
let rwGwpInitialized = false;

class GwpCustom extends HTMLElement
{
    constructor()
    {
        super();
        this.setup();
    }

    setup() {

        // Init

        this.compareFullPrice = false; // use the total before discounts, or after discounts?
        this.validOffer = null;
        this.validOfferItemsInCart = [];
        this.validOffers = [];
        this.cartTotal = (this.dataset.cartTotal ? (parseInt(this.dataset.cartTotal) + 0.0) / 100.0 : 0.00);
        this.cartItemsRaw = ('' + this.dataset.cartItems).split(',');
        if (this.cartItemsRaw.length == 1 && this.cartItemsRaw[0] == '') {
            this.cartItemsRaw = [];
        } else if (this.cartItemsRaw && this.cartItemsRaw[this.cartItemsRaw.length - 1] == '') {
            this.cartItemsRaw.pop();
        }

        // Setup data

        this.cartItems = [];
        this.cartHandles = [];
        this.cartPromoItems = [];
        for (let i = 0; i < this.cartItemsRaw.length; i++) {
            let ar = this.cartItemsRaw[i].split(':');
            let itemHandle = ar[3];
            this.cartHandles.push(itemHandle);
            if (ar.length >= 3 && ar[2] != '') {
                this.cartPromoItems.push(ar[0] + ':' + ar[2]);
            }
            const itemPrice = parseInt(ar[4]) / 100.0;
            const discountAmt = parseInt(ar[5]) / 100.0;

            this.cartItems.push({
                id: ar[0],
                qty: parseInt(ar[1]),
                handle: itemHandle,
                gwp: ar[2],
                price: itemPrice,
                fullPrice: itemPrice + discountAmt,
                discount: discountAmt,
                onSale: (ar.length >= 7 && ar[6] == 'sale'),
                markdown: (ar.length >= 8 && ar[7] == 'true' ? true : false),
            });
        }

        // this.log(['[GwpCustom.constructor] cartTotal = ', this.cartTotal, ' [' + typeof(this.cartTotal) + ']']);
        // this.log(['[GwpCustom.constructor] cartItemsRaw = ', this.cartItemsRaw, ' /// ', this.cartPromoItems, ' /// ', this.cartHandles]);
        this.log(['[GwpCustom.constructor] cartItems = ', this.cartItems]);
        this.log(['[GwpCustom.constructor] cartPromoItems = ', this.cartPromoItems]);
        this.offers = window.gwpCustomOffers; // provided by an app block extension; if the app isn't enabled then this will be null
        this.container = this.querySelector('.cart-freeshipping__product-inner');
        this.log(['[GwpCustom.constructor] rwGwpInitialized = ', rwGwpInitialized, ' / typeof(offers) = ', typeof(this.offers)]);

        // If GWP initialized, then initialize this offer
        if (rwGwpInitialized && typeof(this.offers) === 'object') {
            this.initGwp();
        }

        // Add additional cart messages
        // this.updateCartMessages();

        // Check for orphaned cart items
        // this.checkGwpCartItems();
    }

    log(args) {
        if (rwGwpDebug) {
            console.log(...args);
        }
    }

    async initGwp() {

        if (typeof(this.offers) === 'undefined') {
            this.offers = window.gwpCustomOffers;
            if (typeof(this.offers) === 'undefined') {
                return;
            }
        }

        this.validOffer = this.getValidOffer();

        if (this.validOffer) {
            // If GWP initialized, then build it
            if (rwGwpInitialized) {
                this.buildGwp(this.validOffer);
            }
        } else {
            this.classList.add('hidden');
        }

        // Add additional cart messages
        this.updateCartMessages();

        // Check for orphaned cart items
        if (typeof(window.cartService) === 'undefined') {
            setTimeout(() => {
            this.checkGwpCartItems();
            }, 1000)
        } else {
            this.checkGwpCartItems();
        }

        this.log(['[GwpCustom.initGwp] validOffer=', (this.validOffer ? this.validOffer.title : 'NULL')]);
        this.log(['[GwpCustom.initGwp] window.gwpCustomOffers=', window.gwpCustomOffers]);

        this.container.addEventListener('click', (e) => {
            if (e.target.tagName != 'BUTTON' && e.target.tagName != 'PRODUCT-QUICK-ADD') {
                let prodButton = e.target.closest('.cart-freeshipping__product-item');
                if (prodButton) {
                    prodButton = prodButton.querySelector('product-quick-add');
                }
                if (prodButton && (typeof(prodButton.dataset.disabled) === 'undefined' || !prodButton.dataset.disabled)) {
                    prodButton.dispatchEvent(new CustomEvent('click'));
                }
            }
        });
    }

    getOfferRef() {
        let offerRef = {};
        const numOffers = (typeof(this.offers) === 'object' ? this.offers.length : 0);
        for (let i = 0; i < numOffers; i++) {
            offerRef[this.offers[i].id] = i;
        }
        return offerRef;
    }

    async checkGwpCartItems() {

        const offerRef = this.getOfferRef();
        const itemKeys = (typeof(this.dataset.cartItemKeys) === 'string' ? this.dataset.cartItemKeys.split('||') : []);
        let offerItemCount = {};

        for (let i = 0; i < this.cartItems.length; i++) {
            if (!this.cartItems[i].gwp || this.cartItems[i].discount > 0.0 || typeof(offerRef[this.cartItems[i].gwp]) === 'undefined') {
                continue;
            }

            const offer = this.offers[offerRef[this.cartItems[i].gwp]];
            if (offer && typeof(offerItemCount[offer.id]) === 'undefined') {
                offerItemCount[offer.id] = [];
            }
            if (!offer || !offer.removeNonDiscountedGwp) {
                continue;
            }

            if (i < itemKeys.length && itemKeys[i]) {
                offerItemCount[offer.id].push(itemKeys[i]);
            }

            // console.log('[GwpCustom.checkGwpCartItems] |GWPITEM| ', this.cartItems[i].handle, ' :: price=', this.cartItems[i].price, ' / discount=', this.cartItems[i].discount, ' / ', this.validOfferItemsInCart, ' / offerItemCount=', offerItemCount[offer.id].length);
            if ((this.validOfferItemsInCart.indexOf(offer.id) >= 0 || this.validOffers.indexOf(offer.id) >= 0) && (!offer.onePerOrder || offerItemCount[offer.id].length <= 1)) {
                // console.log('[GwpCustom.checkGwpCartItems] never mind');
                continue; // offer is only invalid because the item is already in the cart, or another offer has priority; leave the item there
            }

            if (i < itemKeys.length && itemKeys[i]) {
                const itemToRemove = document.querySelector('cart-slideout cart-item[data-line-key="' + itemKeys[i] + '"]');
                if (itemToRemove) {
                    this.log(['[GwpCustom.checkGwpCartItems] remove item from cart: ', itemKeys[i]]);
                    await window.cartService.updateCart({[itemKeys[i]]:0});
                    break; // best to stop here; widget will refresh and run this again, any other items will get picked up later
                }
            }
        }
    }

    updateCartMessages() {

        const offerRef = this.getOfferRef();
        const cartPage = document.querySelector('cart-page');

        document.querySelectorAll('cart-slideout cart-item').forEach((cartItem) => {
            if (cartItem.dataset.isRwgwp && cartItem.dataset.rwgwp != '' && typeof(offerRef[cartItem.dataset.rwgwp]) !== 'undefined') {
                const offer = this.offers[offerRef[cartItem.dataset.rwgwp]];
                if (offer && this.validOfferItemsInCart.indexOf(offer.id) < 0 && this.validOffers.indexOf(offer.id) < 0) {
                    if ((typeof(offer.notDiscountedMessage) === 'string' && offer.notDiscountedMessage != '') || (typeof(offer.warningMsg) === 'string' && offer.warningMsg != '')) {
                        const discountAmt = parseInt(cartItem.dataset.discount);
                        if (!isNaN(discountAmt)) {
                            // console.log('|[' + cartItem.dataset.lineProductid + '] discountAmt=', discountAmt, ' / expected percent discount = ', offer.giftDiscountPercent, ' / price = ', cartItem.dataset.price);
                            if (discountAmt == 0 || (offer.giftDiscountPercent == 100 && cartItem.dataset.price != 0)) {
                                this.addCartItemMessage(cartItem, (offer.warningMsg ? offer.warningMsg : offer.notDiscountedMessage));
                                if (cartPage) {
                                    const cartPageItem = document.querySelector('cart-page cart-item[data-line-key="' + cartItem.dataset.lineKey + '"]');
                                    if (cartPageItem) {
                                        this.addCartItemMessage(cartPageItem, (offer.warningMsg ? offer.warningMsg : offer.notDiscountedMessage));
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }

    addCartItemMessage(cartItem, msg) {
        let msgContainer = cartItem.querySelector('.cart-item-info > .cart-item-info__gift-msg');
        if (!msgContainer) {
            msgContainer = document.createElement('div');
            msgContainer.classList.add('cart-item-info__gift-msg');
            cartItem.querySelector('.cart-item-info').append(msgContainer);
        }
        msgContainer.classList.add('text-critical');
        msgContainer.classList.add('text-xs');
        msgContainer.innerHTML = msg;
    }

    getValidOffer() {

        const numOffers = (typeof(this.offers) === 'object' ? this.offers.length : 0);
        let validOffer = null;
        this.validOfferItemsInCart = [];
        this.validOffers = [];
        let fallbackOffers = [];

        if (numOffers <= 0) {
            return null;
        }
        for (let i = 0; i < numOffers; i++) {
            const offer = this.offers[i];

            this.log(['[GwpCustom.getValidOffer] |[' + offer.id + '] ', offer.title, ' :: ', offer.status]);
            // console.log(offer);

            if (offer.products.length == 0) { // no products to show, no point in this offer
                this.log(['[GwpCustom.getValidOffer] not valid: no products to show']);
                continue;
            }

            if (!offer.applyWithOtherGwp) {
                let hasOtherGwp = false;
                for (let j = 0; j < this.cartItems.length; j++) {
                    if (this.cartItems[j].gwp != '' && this.cartItems[j].gwp != offer.id) {
                        hasOtherGwp = true;
                        break;
                    }
                }
                if (hasOtherGwp) {
                    this.log(['[GwpCustom.getValidOffer] not valid: another GWP offer applied']);
                    continue;
                }
            }

            // Get cart gift count

            let giftProdQty = 0;
            for (let j = 0; j < this.cartItems.length; j++) {
                if (this.cartItems[j].gwp == offer.id) {
                    giftProdQty += this.cartItems[j].qty;
                }
            }

            let giftCount = 0;
            if (offer.requiredProducts.length == 0 && offer.minOrderAmount > 0) {
                giftCount = offer.giftsToReceive;
            } else if (offer.onePerOrder) {
                giftCount = (reqProdQty >= offer.minProductsRequired ? offer.giftsToReceive : 0);
            } else {
                let numGroups = (offer.minProductsRequired > 0 ? Math.floor(Math.round(reqProdQty / offer.minProductsRequired * 1000.0) / 1000.0) : 1);
                giftCount = numGroups * offer.giftsToReceive;
            }
            giftCount -= giftProdQty;

            // Check min order amount

            let offerCartTotal = 0.00;
            for (let j = 0; j < this.cartItems.length; j++) {
                if ((!offer.excludedTotalProducts || offer.excludedTotalProducts.indexOf(this.cartItems[j].handle) < 0) && this.cartItems[j].gwp == '' && 
                        (!offer.minAmountNonSale || !this.cartItems[j].onSale) && 
                        (!offer.excludeMarkdownVariants || !this.cartItems[j].markdown)
                    ) {
                    offerCartTotal += (this.compareFullPrice ? this.cartItems[j].fullPrice : this.cartItems[j].price);
                }
            }
            offerCartTotal = Math.round(offerCartTotal * 100.0) / 100.0;

            this.log(['[GwpCustom.getValidOffer] offer.excludedTotalProducts=', offer.excludedTotalProducts, ' / offerCartTotal=', offerCartTotal, ' / offer.minAmountNonSale=', offer.minAmountNonSale, ' / offer.minOrderAmount=', offer.minOrderAmount]);
            // this.log(['[GwpCustom.getValidOffer] offerCartTotal=', offerCartTotal]);
            // this.log(['[GwpCustom.getValidOffer] minAmountNonSale=', offer.minAmountNonSale]);
            // this.log(['[GwpCustom.getValidOffer] minOrderAmount=', offer.minOrderAmount]);

            if (offerCartTotal < offer.minOrderAmount) { // check required min order amount
                this.log(['[GwpCustom.getValidOffer] not valid: offerCartTotal < minOrderAmount (' + offerCartTotal + ' < ' + offer.minOrderAmount + ')']);
                if (offer.alwaysShow && offerCartTotal > offer.alwaysShowAmount && giftCount > 0) {
                    fallbackOffers.push(offer);
                }
                continue;
            }

            // Check if the required products are in the cart

            let isValid = false, reqProdQty = 0;
            if (offer.requiredProducts.length > 0) {
                // if (offer.requiredProductsInCart === null) {
                //     offer.requiredProductsInCart = offer.requiredProducts.filter((prodHandle) => {
                //         return (this.cartHandles.indexOf(prodHandle) >= 0);
                //     });
                // }

                for (let j = 0; j < this.cartItems.length; j++) {
                    if (offer.requiredProducts.indexOf(this.cartItems[j].handle) >= 0) {
                        if (!offer.excludeSaleProducts || !this.cartItems[j].onSale) {
                            reqProdQty += this.cartItems[j].qty;
                        }
                    }
                }

                this.log(['[GwpCustom.getValidOffer] offer.requiredProducts=', offer.requiredProducts, ' / reqProdQty=', reqProdQty]);
                this.log(['[GwpCustom.getValidOffer] this.cartPromoItems=', this.cartPromoItems]);

                if (reqProdQty >= offer.minProductsRequired) { // are the required products in the cart?
                    isValid = true;
                }
            } else if (offer.minOrderAmount > 0) { // only allow the offer when no qualifying products specified when min order amount used?
                isValid = true;
            }

            // Check if gifts are already in the cart

            if (isValid) {
                this.log(['[GwpCustom.getValidOffer] giftProdQty = ', giftProdQty, ' / ', giftCount, ' still to add for this offer']);

                if (giftCount > 0) { // do we have enough gifts in the cart already?
                    if (!validOffer) {
                        validOffer = offer;
                    }
                    this.validOffers.push(offer.id);
                } else {
                    this.log(['[GwpCustom.getValidOffer] not valid: gifts already in cart (crit: ' + giftProdQty + ' < ' + offer.giftsToReceive + ')']);
                    this.validOfferItemsInCart.push(offer.id);
                }
            } else {
                this.log([
                    '[GwpCustom.getValidOffer] not valid: ' +
                    (offer.requiredProducts.length > 0 ? 'not enough required products (crit: ' + reqProdQty + ' >= ' + offer.minProductsRequired + ')' : 'not meeting criteria, no min amount either')
                ]);
                if (offer.alwaysShow && offerCartTotal > offer.alwaysShowAmount) {
                    fallbackOffers.push(offer);
                }
            }
        }

        if (!validOffer && fallbackOffers.length > 0) {
            validOffer = fallbackOffers[0];
            this.log(['[GwpCustom.getValidOffer] selected fallback offer: ', (validOffer ? validOffer.title : 'NULL')]);
        }

        return validOffer;
    }

    async loadCollectionProductsFromApi(collectionList, fullProdCollectionsToLoad) {

        let gvars = {};
        let gquery = `query collection(`;
        for (let i = 0; i < collectionList.length; i++) {
            gquery += `${(i > 0 ? ', ' : '')}\$handle${i + 1}: String!`;
            gvars['handle' + (i + 1)] = collectionList[i];
        }
        gquery += `) {\n`;
        let gqueryList = [];
        for (let i = 0; i < collectionList.length; i++) {
            const fullProdCollection = (fullProdCollectionsToLoad.indexOf(collectionList[i]) >= 0);
            gqueryList.push(`  collection${i + 1}: collection(handle: \$handle${i + 1}) {
                handle
                products(first: 250) {
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                  nodes {
                    handle
                    ${fullProdCollection ? 'title, id, availableForSale' : ''}
                    ${fullProdCollection ? 'variantsCount { count }' : ''}
                    ${fullProdCollection ? 'priceRange { minVariantPrice { amount }, maxVariantPrice { amount } }' : ''}
                    ${fullProdCollection ? 'selectedOrFirstAvailableVariant { id }' : ''}
                    ${fullProdCollection ? 'featuredImage { url }' : ''}
                  }
                }
              }`);
        }
        gquery += gqueryList.join('\n');
        gquery += `}`;
        // this.log(['[GwpCustom.loadCollectionProductsFromApi] gquery = ', gquery]);
        // this.log(['[GwpCustom.loadCollectionProductsFromApi] gvars = ', gvars]);

        // Load collections and products

        const resp = await fetch(CHROMA.apis.storefront.endpoint, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Shopify-Access-Token": CHROMA.apis.storefront.accessToken
            },
            body: JSON.stringify({
                query: gquery,
                variables: gvars
            }),
        });

        const result = await resp.json();
        this.log(['[GwpCustom.loadCollectionProductsFromApi] result = ', result]);

        // Check for any with more than 250 products, load extra pages

        if (result && typeof(result.data) !== 'undefined') {
            let newQueryList = [], numQueries = 0;
            do {
                let num = 0, newGvars = {};
                newQueryList = [];
                for (let collectionNum in result.data) {
                    this.log(['[GwpCustom] ', collectionNum, ' == ', result.data[collectionNum]['handle'], ' == ', 
                        result.data[collectionNum]['products']['nodes'].length, 
                        ' :: hasNextPage=', result.data[collectionNum]['products']['pageInfo']['hasNextPage']]);
                    if (result.data[collectionNum]['products']['pageInfo']['hasNextPage']) {
                        let nextPageGquery = gqueryList[num];
                        nextPageGquery = nextPageGquery.replace('products(first: 250)', 'products(first: 250, after: "' + result.data[collectionNum]['products']['pageInfo']['endCursor'] + '")');
                        newQueryList.push(nextPageGquery);
                        newGvars['handle' + (num + 1)] = gvars['handle' + (num + 1)];
                    }
                    num++;
                }

                if (newQueryList.length > 0) {
                    gquery = '';
                    for (let collectionHandle in newGvars) {
                        gquery += (gquery != '' ? ', ' : '') + '$' + collectionHandle + ': String!';
                    }
                    gquery = `query collection(${gquery}) {\n`;
                    gquery += newQueryList.join('\n');
                    gquery += `\n}`;
                    // this.log(['[GwpCustom][' + numQueries + '] ', gquery]);
                    this.log(['[GwpCustom][' + numQueries + '] ', newGvars]);

                    const resp2 = await fetch(CHROMA.apis.storefront.endpoint, {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "X-Shopify-Access-Token": CHROMA.apis.storefront.accessToken
                        },
                        body: JSON.stringify({
                            query: gquery,
                            variables: newGvars
                        }),
                    });

                    const result2 = await resp2.json();
                    if (typeof(result2.data) !== 'undefined') {
                        for (let collectionNum in result2.data) {
                            result.data[collectionNum]['products']['nodes'] = [
                                ...result.data[collectionNum]['products']['nodes'],
                                ...result2.data[collectionNum]['products']['nodes']
                            ];
                            result.data[collectionNum]['products']['pageInfo'] = result2.data[collectionNum]['products']['pageInfo'];
                        }
                        this.log(['[GwpCustom.loadCollectionProductsFromApi] result[' + numQueries + '] = ', result]);
                    } else {
                        break;
                    }
                    numQueries++;
                }
            } while (newQueryList.length > 0 && numQueries < 5);
        }
        return result;
    }

    async loadCollectionProducts(validOffer) {
        let collectionList = [...validOffer.collectionsToLoad];
        validOffer.collectionsToLoad = [];
        this.log(['[GwpCustom.loadCollectionProducts] collections: ', collectionList, ' / ', validOffer.collectionsToLoad]);

        const result = await this.loadCollectionProductsFromApi(collectionList, validOffer.fullProdCollectionsToLoad);
        this.log(['[GwpCustom.loadCollectionProducts] result = ', result]);

        // Process loaded products

        if (result && typeof(result.data) !== 'undefined') {
            const discountDec = (validOffer.giftDiscountPercent / 100.0);
            for (let collectionNum in result.data) {
                const col = result.data[collectionNum];
                let handle = col['handle'];
                if (validOffer.giftCollections.indexOf(handle) >= 0) {

                    for (let i = 0; i < col.products.nodes.length; i++) {
                        const prod = col.products.nodes[i];
                        let newPrice = (prod['priceRange'] ? parseFloat(prod['priceRange']['minVariantPrice']['amount']) : 0.00);
                        newPrice = (validOffer.giftDiscountPercent != 100.0 ? (Math.round((newPrice * 100.0) - (newPrice * discountDec * 100.0)) / 100.0) : 0.00);
                        let formattedPrice = this.formatPrice(newPrice);
                        if (formattedPrice !== '') {
                            if (prod['priceRange']['minVariantPrice']['amount'] != prod['priceRange']['maxVariantPrice']['amount']) {
                                formattedPrice = 'From ' + formattedPrice;
                            }
                        }

                        let prodId = this.getShortId('' + prod['id']);
                        let firstVariantId = (prod['selectedOrFirstAvailableVariant'] ? this.getShortId('' + prod['selectedOrFirstAvailableVariant']['id']) : '');

                        validOffer.products.push({
                            title: prod['title'],
                            handle: prod['handle'],
                            id: prodId,
                            numVariants: (prod['variantsCount'] ? prod['variantsCount']['count'] : 0),
                            newPrice: formattedPrice,
                            image: (prod['featuredImage'] ? prod['featuredImage']['url'] + '&width=150' : ''),
                            firstVariantId: firstVariantId,
                            available: (prod['availableForSale'] ? true : false),
                        });
                    }

                }
                
                if (validOffer.reqCollections.indexOf(handle) >= 0) {
                    for (let i = 0; i < col.products.nodes.length; i++) {
                        const prod = col.products.nodes[i];
                        validOffer.requiredProducts.push(prod.handle);
                    }
                }

                if (validOffer.exclCollections.indexOf(handle) >= 0) {
                    for (let i = 0; i < col.products.nodes.length; i++) {
                        const prod = col.products.nodes[i];
                        validOffer.excludedTotalProducts.push(prod.handle);
                    }
                }
            }
        }
        validOffer.fullProdCollectionsToLoad = [];
    }

    formatPrice(price, showCurrency) {
        if (typeof(showCurrency) === 'undefined') {
            showCurrency = true;
        }
        let formattedPrice = '' + price;
        if (formattedPrice.indexOf('.') < 0) {
            formattedPrice += '.00';
        } else if (formattedPrice.indexOf('.') == formattedPrice.length - 2) {
            formattedPrice += '0';
        }
        if (typeof(CHROMA.moneyFormatting) !== 'undefined') {
            formattedPrice = (price > 0.00 && showCurrency ? 
                '' + CHROMA.moneyFormatting.moneyFormatCurrency.replace('{{amount}}', formattedPrice) :
                '' + CHROMA.moneyFormatting.moneyFormat.replace('{{amount}}', formattedPrice));
        }
        return formattedPrice;
    }

    getShortId(inId) {
        if (inId.indexOf('/') >= 0) {
            inId = inId.substring(inId.lastIndexOf('/') + 1, inId.length);
        }
        return inId;
    }

    buildGwp(offer) {
        this.log(['[GwpCustom.buildGwp] offer=', offer, ' / container=', this.container, ' / offercount=' + this.offers.length]);
        let numValidItems = 0;
        let desc = '' + offer.description;

        this.querySelector('.cart-freeshipping__heading').innerText = offer.heading;
        this.querySelector('.cart-freeshipping__description').innerText = desc;
        if (offer.description) {
            this.querySelector('.cart-freeshipping__description').classList.remove('hidden');
        }

        let products = [...offer.products];
        let productInfo = [];
        let lockMsg = offer.lockedMessage;
        if (!lockMsg || typeof(lockMsg) !== 'string') {
            lockMsg = 'SPEND [amount] TO UNLOCK';
        }
        let bannerMsg = offer.productBanner;
        if (!bannerMsg || typeof(bannerMsg) !== 'string') {
            bannerMsg = '';
        }

        for (let j = 0; j < products.length; j++) {
            const remainingAmount = offer.minOrderAmount - this.cartTotal;
            const remainingAmtFormatted = this.formatPrice(Math.round(remainingAmount * 100.0) / 100.0, false);
            if (offer.alwaysShow && this.cartTotal > offer.alwaysShowAmount && this.cartTotal < offer.minOrderAmount) {
                productInfo.push({banner: lockMsg.replace('[amount]', remainingAmtFormatted), enabled: false, offerId: offer.id});
            } else {
                productInfo.push({banner: bannerMsg.replace('[amount]', remainingAmtFormatted), enabled: true, offerId: offer.id, bannerColour: offer.bannerColour, bannerTextColour: offer.bannerTextColour});
            }
        }

        // Include products from other offers?

        if (offer.includeOtherOffers) {
            for (let i = 0; i < this.offers.length; i++) {
                if (this.offers[i].id != offer.id && this.offers[i].status == 'active' && this.offers[i].minOrderAmount > 0.0) {

                    const offerProdIds = this.offers[i].products.map((item) => { return '' + item.id; });
                    const numAlreadyInCart = this.cartPromoItems.filter((item) => {
                        return offerProdIds.indexOf(item.substring(0, item.indexOf(':'))) >= 0;
                    }).length;
                    // console.log('** CHECK OFFER ' + this.offers[i].title + ' *** // ', offerProdIds, ' :: ', numAlreadyInCart);
                    if (numAlreadyInCart >= this.offers[i].giftsToReceive) {
                        continue; // already enough gifts in the cart from this offer
                    }

                    lockMsg = this.offers[i].lockedMessage;
                    if (!lockMsg || typeof(lockMsg) !== 'string') {
                        lockMsg = 'SPEND [amount] TO UNLOCK';
                    }

                    bannerMsg = this.offers[i].productBanner;
                    if (!bannerMsg || typeof(bannerMsg) !== 'string') {
                        bannerMsg = '';
                    }

                    let otherProducts = [...this.offers[i].products];
                    for (let j = 0; j < otherProducts.length; j++) {
                        const remainingAmount = this.offers[i].minOrderAmount - this.cartTotal;
                        const remainingAmtFormatted = this.formatPrice(Math.round(remainingAmount * 100.0) / 100.0, false);
                        if (this.cartTotal < this.offers[i].minOrderAmount) {
                            productInfo.push({banner: lockMsg.replace('[amount]', remainingAmtFormatted), enabled: false, offerId: this.offers[i].id});
                        } else {
                            productInfo.push({banner: bannerMsg.replace('[amount]', remainingAmtFormatted), enabled: true, offerId: this.offers[i].id, bannerColour: this.offers[i].bannerColour, bannerTextColour: this.offers[i].bannerTextColour});
                        }
                        products.push(otherProducts[j]);
                    }
                }
            }
        }

        for (let j = 0; j < products.length; j++) {
            const prod = products[j];
            const prodKey = '' + prod.id + ':' + offer.id;

            this.log(['[GwpCustom.buildGwp] prod[' + j + '] = ', prod.title]);
            let item = document.createElement('div');
            // let propsJson = JSON.stringify({"_gwp": '' + offer.id, "Free Gift": offer.title});
            let prodInfo = (typeof(productInfo[j]) !== 'undefined' ? productInfo[j] : null);
            let propsJson = JSON.stringify({"_gwp": '' + (prodInfo?.offerId??offer.id)});
            let customPrice = prod.newPrice;
            let bannerContent = (prodInfo?.banner??'');
            let headlineBanner = '';
            let overlayContent = '';
            let enabled = (prodInfo?.enabled??true);

            if (bannerContent) {
                if (enabled) {
                    headlineBanner = '<div class="cart-freeshipping__product-item-headline absolute top-0 left-0 right-0 p-1 text-center text-white" ' + 
                        'style="' + (prodInfo.bannerColour ? 'background-color:' + prodInfo.bannerColour + ';' : '') + (prodInfo.bannerTextColour ? 'color:' + prodInfo.bannerTextColour + ';' : '') + '">' +
                        bannerContent + '</div>';
                    bannerContent = '';
                } else {
                    bannerContent = '<div class="cart-freeshipping__product-item-banner absolute top-0 left-0 right-0 bottom-0 p-1 text-center text-black flex items-center">' + bannerContent + '</div>';
                }
            }

            const buttonText = (enabled ? `Select<span class="hidden${prod.numVariants > 1 ? ' sm:inline' : ''}"> Options</span>` : `Unavailable`);

            item.classList.add('cart-freeshipping__product-item');
            item.classList.add('relative');
            //data-id="gwp-${prod.id}-${j}"
            item.innerHTML = `
                <div class="relative">
                    <img class="${!enabled?'opacity-60':''} cursor-pointer w-full" src="${prod.image}" loading="lazy" width="150" alt="">
                    <div class="${!enabled?'opacity-60':''} pt-3 text-xs cursor-pointer cart-freeshipping__product-item-title">${prod.title}</div>
                </div>
                ${headlineBanner}
                ${bannerContent}
                <product-quick-add ${enabled ? '' : 'data-disabled="1"'} data-action="${prod.numVariants == 1 ? 'add' : 'toggle'}" data-handle="${prod.handle}" data-id="${prod.firstVariantId}" data-props='${propsJson}' 
                        data-product-id="${prod.id}" ${customPrice !== null ? 'data-price="' + customPrice + '"' : ''} ${prod.numVariants == 1 ? 'data-option-name="' + prod.title + '"' : ''}
                        class="mt-auto pt-3 block">
                    <button type="button" ${!enabled?'disabled':''} class="button-secondary button-small text-xs px-2 whitespace-nowrap w-full">${buttonText}</button>
                </product-quick-add>
                ${overlayContent}
            `;
            if (this.cartPromoItems.indexOf(prodKey) >= 0) {
                item.style.order = '9999'; // if this product added for this particular offer, push it to the end
            }
            this.container.append(item);
            numValidItems++;
        }
        this.container.classList.add('cart-freeshipping__product-inner--x' + offer.products.length);

        if (numValidItems == 0) {
            // @TODO: what to do? this means no products shown, despite offer still being valid
            this.log(['[GwpCustom.buildGwp] NOT SHOWING OFFER / numValidItems = ', numValidItems]);
            return;
        }

        this.classList.remove('hidden');
    }
}
customElements.get("gwp-custom")||customElements.define("gwp-custom", GwpCustom);

// Custom cart messages

class GwpCustomMessages extends HTMLElement
{
    constructor()
    {
        super();
        this.msgContainer = this.querySelector('div');
        this.cartSlideout = this.closest('cart-slideout');
        this.setup();
    }

    setup() {

        // console.log('[GwpCustomMessages.setup] cart-slideout = ', this.cartSlideout);
        this.classList.toggle('hidden', true);
        if (this.cartSlideout) {
            this.updateDiscountList();
        }

    }

    updateDiscountList() {

        let messageTpl = 'A discount was removed from <b>[title]</b>. Gifts not available with other offers.';

        // 1. Get prev discount list from sessionStorage

        const excludeGwpItems = true;
        const prevDiscountJson = sessionStorage.getItem('prev_discount_list');
        let prevDiscountList = (prevDiscountJson ? JSON.parse(prevDiscountJson) : []);
        let idList = prevDiscountList.map((item) => { return item.id; });
        let cartIdList = [];
        let msgList = [];

        // console.log('prevDiscountList before = ', prevDiscountList);

        // 2. Go through cart item list
        //   - if item is discounted and not GWP, and not in prevDiscountList, add it
        //   - if item is NOT discounted and not GWP, and in prevDiscountList, add to msg list
        //   - save each id to a cart item list

        document.querySelectorAll('cart-slideout cart-item').forEach((item) => {
            if (item.dataset.isRwgwp && excludeGwpItems) {
                return;
            }

            const curTimestamp = (new Date()).getTime();

            // console.log('|[' + item.dataset.lineId + '] ' + item.dataset.lineTitle + ' // productId=' + item.dataset.lineProductid + ' / discount=' + item.dataset.discount);
            cartIdList.push('' + item.dataset.lineId);

            if (typeof(item.dataset.discount) !== 'undefined' && item.dataset.discount !== '') {
                let discountAmt = parseInt(item.dataset.discount);
                let itemId = '' + item.dataset.lineId;
                if (!isNaN(discountAmt) && discountAmt > 0) {
                    if (idList.indexOf(itemId) < 0) {
                        prevDiscountList.push({
                            'id': itemId,
                            'discount': discountAmt,
                            'prevDiscount': discountAmt,
                            'tm': curTimestamp
                        });
                        idList.push(itemId);
                    } else {
                        prevDiscountList[idList.indexOf(itemId)].discount = discountAmt;
                    }
                } else if (idList.indexOf(itemId) >= 0 && !isNaN(discountAmt)) {
                    let prevDiscount = prevDiscountList[idList.indexOf(itemId)];
                    if (typeof(prevDiscount) !== 'undefined') {
                        if (prevDiscount.discount != discountAmt) {
                            prevDiscount.discount = discountAmt;
                            prevDiscount.tm = curTimestamp; // reset timestamp
                        }
                        const timeSince = ((curTimestamp - prevDiscount.tm) / 1000.0);
                        // console.log('msg item = ', prevDiscount, ' / tm diff = ', timeSince, 's');
                        if (timeSince <= 300) {
                            msgList.push(messageTpl.replace(/\[title\]/g, item.dataset.lineTitle));
                        }
                    }
                }
            }
        });

        // 3. Go through prevDiscountList
        //   - if not in cartItemList, remove from prevDiscountList

        prevDiscountList = prevDiscountList.filter((item) => {
            return (cartIdList.indexOf(item.id) >= 0);
        });

        // 4. Save prevDiscountList to sessionStorage

        sessionStorage.setItem('prev_discount_list', JSON.stringify(prevDiscountList));
        // console.log('[GwpCustomMessages.updateDiscountList] prevDiscountList = ', prevDiscountList);
        // console.log('[GwpCustomMessages.updateDiscountList] msgList = ', msgList);

        // 5. Refresh messages box with msgList

        this.msgContainer.innerHTML = (msgList.length > 0 ? '<ul style="list-style:initial;padding:0 0 0 20px"><li>' + msgList.join('</li><li>') + '</li></ul>' : '');
        this.classList.toggle('hidden', (msgList.length <= 0));
    }
}
customElements.get("gwp-custom-messages")||customElements.define("gwp-custom-messages", GwpCustomMessages);

// Initialize

async function initRwGwp() {

    if (rwGwpDebug) {
        console.log('[gwp.js] [start]');
    }

    // Load additional products using storefront API; then initialize each component

    let offerIdList = [], num = 0;
    let elemList = document.querySelectorAll('gwp-custom');

    for (let i = 0; i < elemList.length; i++) {
        const elem = elemList[i];
        num += 1;
        let n = num;
        if (rwGwpDebug) {
            console.log('[initRwGwp][start][' + n + '] validOffer=', (elem.validOffer ? elem.validOffer.id : 'NULL'), ' / collectionsToLoad=', (elem.validOffer ? elem.validOffer.collectionsToLoad : 'NULL'));
        }

        // Load any additional required data for offers (we don't know if the offer is valid until that data is loaded)

        const numOffers = (typeof(elem.offers) === 'object' ? elem.offers.length : 0);
        for (let i = 0; i < numOffers; i++) {
            const offer = elem.offers[i];
            // const cartTotal = parseFloat(elem.cartTotal);
            if (offer.status != 'active') { // || elem.cartTotal < offer.minOrderAmount) {
                console.log('[initRwGwp] |', offer.title, 
                    (offer.status != 'active' ? ' :: NOT ACTIVE (' + offer.status + ')' : '')
                    // (elem.cartTotal < offer.minOrderAmount ? ' :: LESS THAN MIN ORDER AMT (' + cartTotal + ' < ' + offer.minOrderAmount + ') (' + typeof(offer.minOrderAmount) + ')' : '')
                );
                continue;
            }
            if (rwGwpDebug) {
                console.log('[initRwGwp] |', offer.title, ' :: ', offer.status, ' / ', offer.collectionsToLoad);
            }

            if (offerIdList.indexOf(offer.id) < 0) {
                offerIdList.push(offer.id);
                if (offer.collectionsToLoad.length > 0) {
                    await elem.loadCollectionProducts(offer);
                }
            }
        }

        // Initialize GWP element

        elem.initGwp();

        // Build GWP section, if an offer is valid

        if (elem.validOffer) {
            elem.buildGwp(elem.validOffer);
        }

        if (rwGwpDebug) {
            console.log('[gwp-custom][end][' + n + ']');
        }
    }

    if (rwGwpDebug) {
        console.log('[gwp.js] [end]');
    }
    rwGwpInitialized = true;
}

(async () => {

    if (rwGwpDebug) {
        console.log('[gwp.js]');
        console.log('gwp-custom :: num components = ', document.querySelectorAll('gwp-custom').length);
    }

    const cartOpenEvent = (e) => {
        if (rwGwpDebug) {
            console.log('[gwp.js] cart:open event fired!');
        }
        if (!rwGwpInitialized) {
            initRwGwp();
        }
    };

    document.addEventListener('cart:open', cartOpenEvent); // open from item added to cart
    document.addEventListener('miniCart:open', cartOpenEvent); // open from click

    if (document.querySelectorAll('gwp-custom').length > 1) {
        initRwGwp();
    }

})();
